    export function getWinHanaAccountingParameterPrice(client, visitor, extraParameters){
        console.log("(client, visitor)->", client, visitor)
        var res = 0;        
        if(client > 1){
            var tmp = ((client-1) * extraParameters.pricePerCleintForWinAccounting);
            console.log("client price is>", tmp)
            res += tmp;
        }
        if(visitor > 0){
            var tmp = (visitor * extraParameters.pricePerVisitorForWinAccounting);
            console.log("viditor price is>", tmp)
            res += tmp;
        }
        return res;
    }
    export function getSchoolManagementParameterPrice(students, schools, extraParameters){
        var res = 0;        
        if(students > 0){
            var price = 0;
            for(var i=0;i<extraParameters.studentNumberPriceRangeForIndependentSchool.length;i++){
                var p = extraParameters.studentNumberPriceRangeForIndependentSchool[i];
                price = p.price;
                if(students<=p.count){
                    break;
                }
            }
            res += price;
        }
        if(schools > 0){
            res += (schools * extraParameters.pricePerSubSchoolForSchoolManagment);
        }
        console.log("(students, schools, res)->", students, schools, res)
        return res;
    }
    export function getSandooghManagementParameterPrice(members, extraParameters){
        var res = 0;        
        if(members > 0){
            var price = 0;
            for(var i=0;i<extraParameters.memberNumberPriceRangeForLoanCenter.length;i++){
                var p = extraParameters.memberNumberPriceRangeForLoanCenter[i];
                price = p.price;
                if(members<=p.count){
                    break;
                }
            }
            res += price;
        }
        console.log("(members, res)->", members, res)
        return res;
    }
    export function getTaxServiceParameterPrice(bills, extraParameters){
        var res = 0;        
        if(bills > 0){
            var price = 0;
            for(var i=0;i<extraParameters.billNumberPriceRangeForTaxService.length;i++){
                var p = extraParameters.billNumberPriceRangeForTaxService[i];
                price = p.price;
                if(bills<=p.count){
                    break;
                }
            }
            res += price;
        }
        console.log("(bills, res)->", bills, res)
        return res;
    }
